import {Box, HBox} from '../../components/core/view';

import BunchaWithoutName from '../../components/core/icon/BunchaWithoutName';
import {H5Text} from '../../components/core/text';
import If from '@buncha/components/conditional/If';
import {HomeScreens} from '@buncha/home/navigation/types';
import {Modules} from '@buncha/utils/types';
import React from 'react';
import {StyleSheet} from 'react-native';
import {isWeb} from '@buncha/utils/common';
import {useColorThemeType} from '../../appStyles/hooks/theme';
import {useGetLocale} from '@buncha/localization/hooks';

function EmptyActiveOrder() {
  const defaultTheme = useColorThemeType();
  const {body} = useGetLocale(Modules.orders, HomeScreens.DriverOrders) ?? {};
  return (
    <HBox style={styles.mainContainer}>
      <Box>
        <If condition={!isWeb()}>
          <BunchaWithoutName
            width={115}
            height={115}
            fill={defaultTheme?.icon.yellow[200]}
            viewBox="0 0 120 120"
            style={styles.iconStyle}
          />
        </If>
        <H5Text
          style={[
            styles.subText,
            {
              color: defaultTheme?.text.blue[300],
            },
          ]}>
          {body?.noOrders}
        </H5Text>
      </Box>
    </HBox>
  );
}

export default React.memo(EmptyActiveOrder);

const styles = StyleSheet.create({
  mainContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1,
  },
  subText: {
    marginHorizontal: 60,
    marginTop: 10,
  },
  iconStyle: {
    alignSelf: 'center',
  },
});
